import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConPages: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConPageMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConPagesRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConPages", null);
            } else {
                dispatch("receivingWebConPages"); // สถานะ กำลังบันทึก

                axios.get('/webConPages').then(res => {

                    dispatch("receiveWebConPages", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveWebConPages", null);
                    })
            }
        },
        loadWebConPageRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConPage", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConPage");
                axios.get('/webConPages/' + id).then(res => {
                    dispatch("receiveWebConPage", res.data);
                })
            }
        },
        updateWebConPageRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConPage");
            axios.put('/webConPages/' + payload.pages_id, payload).then(res => {
                dispatch("updateWebConPage", res.data);
            })
        },
        createWebConPageRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConPage");
            axios.post('/webConPages', payload).then(res => {
                dispatch("receiveWebConPage", res.data);
            })
        },
        deleteWebConPageRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConPage", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConPage", payload);

            axios.post('/delete_webConPages', payload).then(res => {
                dispatch("deleteWebConPage", {pages_id: payload.pages_id, res: res});
            })


        },
        receiveWebConPages({commit}, payload) {
            commit("RECEIVED_PREFIXS", payload)
        },
        receivingWebConPages({commit}) {
            commit("RECEIVING_PREFIXS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConPage({commit}, payload) {
            commit("RECEIVED_PREFIX", payload)
        },
        receivingWebConPage({commit}) {
            commit("RECEIVING_PREFIXS") //call matutions --> state.isReceiving = true;
        },
        updateWebConPage({commit}, payload) {
            commit("UPDATED_PREFIX", payload)
        },
        updatingWebConPage({commit}) {
            commit("UPDATING_PREFIX") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConPage({commit}, payload) {
            commit("DELETED_PREFIX", payload)
        },
        deletingWebConPage({commit}, payload) {
            commit("DELETING_PREFIX", payload)
        },
        afterDeleteWebConPage({commit}, payload) {
            commit("AFFTER_DELETED_PREFIX", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_PREFIXS(state, payload) {
            state.webConPages = payload;
            state.isReceiving = false;

        },
        RECEIVING_PREFIXS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_PREFIX(state, payload) {


            if (payload.page_url == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let webConPageMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConPageMessage: (state.webConPageMessage == webConPageMessage ? webConPageMessage + ' ' : webConPageMessage),

                });
            } else {
                let webConPageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.page_url + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConPages: [...state.webConPages, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConPageMessage: (state.webConPageMessage == webConPageMessage ? webConPageMessage + ' ' : webConPageMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_PREFIX(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_PREFIX(state, payload) {
            let index = state.webConPages.findIndex(p => p.page_url === payload.page_url);
            let webConPageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.page_url + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConPages: state.webConPages.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConPageMessage: (state.webConPageMessage == webConPageMessage ? webConPageMessage + ' ' : webConPageMessage),
            })
        },
        UPDATING_PREFIX(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_PREFIX(state, payload) {


            if (payload.pages_id == undefined || payload.res.data.message == 'Relation') {
                let webConPageMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.page_url;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConPageMessage: (state.webConPageMessage == webConPageMessage ? webConPageMessage + ' ' : webConPageMessage),

                });
            } else {
                let indexToDelete = state.webConPages.findIndex(p => p.page_url === payload.page_url);
                let webConPages = [...state.webConPages];
                webConPages.splice(indexToDelete, 1);
                let webConPageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.page_url + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConPages: [...webConPages],
                    isDeleting: false,
                    idToDelete: null,
                    webConPageMessage: (state.webConPageMessage == webConPageMessage ? webConPageMessage + ' ' : webConPageMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_PREFIX(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.page_url;
        },
        AFFTER_DELETED_PREFIX(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
